import { Grid, Typography } from "@mui/material";

const Service = () => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 0, color: '#378dab'}}>
                    Activities
                </Typography>
            </Grid>        
            
            <Grid item xs={12}>
                <ul style={{fontStyle: 'italic'}}>                                        
                    <li>Personal Project: Vehicle License Plate Detection Tool - Image Processing (Fall 2018)</li>                    
                    <li>Personal Project: Plagiarism Checker Software - Python Programming (Spring 2017)</li>                                        
                </ul>
            </Grid>        
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 0, color: '#378dab'}}>
                    Work Experiences
                </Typography>
            </Grid>        
            
            <Grid item xs={12}>
                <ul style={{fontStyle: 'italic'}}>
                    <li>Senior Software Engineer, Clanz, Sydney, Australia (2022)</li>                   
                    <li>Intern, XaaS Cloud Computing, Tehran, Iran (2019)</li>
                    <li>Order Matching Engine Developer, Innovation, Sydney, Australia (2018)</li>                                       
                </ul>
            </Grid>                   
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 0, color: '#378dab'}}>
                    Other Interests
                </Typography>
            </Grid>        
            
            <Grid item xs={12}>
                <ul style={{fontStyle: 'italic'}}>
                <li>Operating Systems: I'm always interested to learn more about Operating Systems. They are like playing field for me.</li>                    
                    <li>HTTP 1.1 Protocol: One of the most interesting protocols I found, which made our lives easier by enabling WWW and lots of other applications.</li>                    
                    <li>Web Security: I'm interested in web applications bug hunting and penetration test.</li>                    
                    <li>Playing Music <Typography variant='span' fontStyle={"italic"}>(I'm a multi-instrumentalist)</Typography></li>
                    <li>Walking</li>
                    <li>Roadtrips</li>
                </ul>
            </Grid>                   
        </Grid>
    )
};

export default Service;